<template lang="pug">
  ul.d-flex
    li.itens.list-complete-item(v-for="item in breadcrumb" :key="item.title")
      span.item(@click="route(item)" :class="{'c-hand': item.name}") {{item.title}}
      span.separador /
</template>

<script>
export default {
  props: {
    breadcrumb: { required: true, type: Array },
    params: { required: true, type: Object },
  },

  methods: {
    route({ name, params }) {
      if (name) {
        const route = { name }
        if (params) {
          route.params = {}
          params.forEach(param => {
            route.params[param] = this.params[param]
          })
        }
        this.$router.push(route)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../styles/_colors.styl'
ul
  margin-left 0
li.itens
  list-style none
  margin 0
  &:not(:last-child)
    .item
      color #3b4351
    .separador
      margin 0 .4em
      color #aaa
  &:last-child
    cursor default
    .item
      color primary
    .separador
      display none
@media(max-width:959px)
  ul
    margin-left 70px
    li.itens
       &:not(:last-child)
        display none
</style>
